import {
  buildOfferingCreateDraftStorageKey,
  type OfferingCreateDraftScope,
} from "./build-storage-key";

export function clearOfferingCreateDraft(scope: OfferingCreateDraftScope): void {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(buildOfferingCreateDraftStorageKey(scope));
}

export function readOfferingCreateDraft(scope: OfferingCreateDraftScope): string | null {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return null;
  }
  return sessionStorage.getItem(buildOfferingCreateDraftStorageKey(scope));
}

export function writeOfferingCreateDraft(
  scope: OfferingCreateDraftScope,
  serialized: string
): void {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.setItem(buildOfferingCreateDraftStorageKey(scope), serialized);
}
